/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AdminList_lists$ref = any;
export type RevokeAdminInput = {|
  clientMutationId?: ?string,
  id: string,
|};
export type revokeAdminMutationVariables = {|
  input: RevokeAdminInput
|};
export type revokeAdminMutationResponse = {|
  +revokeAdmin: ?{|
    +lists: {|
      +$fragmentRefs: AdminList_lists$ref
    |},
    +revokedAdminIds: $ReadOnlyArray<string>,
  |}
|};
export type revokeAdminMutation = {|
  variables: revokeAdminMutationVariables,
  response: revokeAdminMutationResponse,
|};
*/


/*
mutation revokeAdminMutation(
  $input: RevokeAdminInput!
) {
  revokeAdmin(input: $input) {
    lists {
      ...AdminList_lists
      id
    }
    revokedAdminIds
  }
}

fragment AdminCell_lists on Lists {
  id
}

fragment AdminCell_user on User {
  id
  email
}

fragment AdminList_lists on Lists {
  ...AdminCell_lists
  adminUsers(first: 1000) {
    edges {
      node {
        id
        ...AdminCell_user
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "RevokeAdminInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "revokedAdminIds",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "revokeAdminMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RevokeAdminPayload",
        "kind": "LinkedField",
        "name": "revokeAdmin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Lists",
            "kind": "LinkedField",
            "name": "lists",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AdminList_lists"
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "revokeAdminMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RevokeAdminPayload",
        "kind": "LinkedField",
        "name": "revokeAdmin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Lists",
            "kind": "LinkedField",
            "name": "lists",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "adminUsers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "email",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "adminUsers(first:1000)"
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "AdminList_adminUsers",
                "kind": "LinkedHandle",
                "name": "adminUsers"
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "revokeAdminMutation",
    "operationKind": "mutation",
    "text": "mutation revokeAdminMutation(\n  $input: RevokeAdminInput!\n) {\n  revokeAdmin(input: $input) {\n    lists {\n      ...AdminList_lists\n      id\n    }\n    revokedAdminIds\n  }\n}\n\nfragment AdminCell_lists on Lists {\n  id\n}\n\nfragment AdminCell_user on User {\n  id\n  email\n}\n\nfragment AdminList_lists on Lists {\n  ...AdminCell_lists\n  adminUsers(first: 1000) {\n    edges {\n      node {\n        id\n        ...AdminCell_user\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a5dcf2da3b6b31f28fc98f7617399c90';

module.exports = node;
